import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const SIP_DIAL_STRING_PATTERN = /^[+0-9A-Za-z]+$/;

export function isValidSipDialString(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && SIP_DIAL_STRING_PATTERN.test(trimmed);
}

export function normalizeSipDialString(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;

  const parsed = parsePhoneNumberFromString(trimmed.startsWith('+') ? trimmed : `+${trimmed}`);
  if (parsed?.isValid()) {
    return parsed.format('E.164');
  }

  return trimmed;
}
